import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';

import RegisterEmployeeForm from './RegisterEmployeeForm';

const styles = theme => ({
  container: {
    minHeight: '100vh',
    height: 'auto',
    padding: theme.spacing(4),
  },
  title: {
    fontWeight: theme.typography.fontWeightStrong,
  },
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
    border: '1px solid',
    borderColor: theme.palette.grey[300],
    fontSize: '0.75rem',
    '&:hover': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    },
  },
});

const RegisterEmployee = ({ classes, loading, onRegisterEmployee, params }) => (
  <Grid container justify="center" alignItems="flex-start" className={classes.container}>
    <Grid container justify="flex-end">
      <Typography align="right" color="textSecondary">
        <Hidden xsDown>Já é registrado?</Hidden>
        <Button component={Link} to="/ponto-web" color="inherit" className={classes.button}>
          Bater o Ponto
        </Button>
      </Typography>
    </Grid>

    <Grid item xl={4} lg={6} md={6} sm={8} xs={12} container direction="column">
      <Grid item>
        <Typography variant="h5" color="textSecondary" gutterBottom>
          {params.code === 'gestor' ? 'Finalize seu cadastro' : 'Cadastre-se como funcionário'}
        </Typography>
        {
          params.code !== 'gestor' ?
            <Typography color="textSecondary" paragraph>
              Preencha os campos abaixo para bater o ponto.
            </Typography> :
            null
        }
      </Grid>
      <Grid item>
        <RegisterEmployeeForm gestor={params.code === 'gestor'} onRegisterEmployee={onRegisterEmployee} loading={loading} />
      </Grid>
    </Grid>
  </Grid>
);

RegisterEmployee.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  onRegisterEmployee: PropTypes.func.isRequired,
};

export default withStyles(styles)(RegisterEmployee);
